import {useEffect, useRef} from 'react';

export function useScrollResetOnChange<T extends HTMLElement = HTMLDivElement>(
  triggerKey: unknown,
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = 0;
    }
  }, [triggerKey]);

  return ref;
}
